import React from 'react';
import PostSendModal from '../PostSendModal/PostSendModal';
import { Subtitle, Icon } from '@landing/ui';
import { defaultModalsId } from '../constants';

import * as styles from './SuccessModal.module.scss';

export default function SuccessModal() {
  const icon = () => <Icon name="letter-success" className={styles.icon} />;

  return (
    <PostSendModal Icon={icon} modalID={defaultModalsId.successModal}>
      <div className={styles.wrapper}>
        <Subtitle className={styles.text}>
          {'Спасибо за ваш интерес!\n\rМы свяжемся с вами в ближайшее время.'}
        </Subtitle>
      </div>
    </PostSendModal>
  );
}
